import { useCountdown } from "components/Layouts/Banner/Countdown/useCountdown"
import React from "react"
import type { CountDownRefType } from "types/cms"

import {
  flexColumn,
  colon,
  timer,
  timerName,
  containerVariants,
} from "./CountDown.css"

type Props = {
  countdownData: CountDownRefType
  alignment?: "Left" | "Right" | "Center"
}
export const CountDown: React.FC<Props> = ({ countdownData, alignment }) => {
  const [days, hours, minutes, seconds] = useCountdown(
    countdownData.countdownEndDate
  )
  const Colon = <span className={colon}>:</span>
  return (
    <div
      className={containerVariants[alignment ?? "Left"]}
      data-testid="countdown"
    >
      <div className={flexColumn}>
        <span className={timer}>{days > 0 ? days : 0}</span>
        <span className={timerName}>Days</span>
      </div>
      {Colon}
      <div className={flexColumn}>
        <span className={timer}>{hours > 0 ? hours : 0}</span>
        <span className={timerName}>HRS</span>
      </div>
      {Colon}
      <div className={flexColumn}>
        <span className={timer}>{minutes > 0 ? minutes : 0}</span>
        <span className={timerName}>MINS</span>
      </div>
      {Colon}
      <div className={flexColumn}>
        <span className={timer}>{seconds > 0 ? seconds : 0}</span>
        <span className={timerName}>SECS</span>
      </div>
    </div>
  )
}
